import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { IconButton } from "@material-ui/core";
import { Add as AddIcon, Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, Launch as LaunchIcon } from "@material-ui/icons";
import LoadingOverlay from "../LoadingOverlay";
import Header from "../Header/Header";
import NumDossCISSCT from "../NumDossCISSCT";
import DocMenu from "../DocMenu";
import axios from "axios";
import { Fragment } from "react";
import { changeTitleName, changePdfFileName, changeIndication } from "../../redux/actions/emailAction";
import { fetchCissct, changeIndexValue } from '../../redux/actions/cissctActions';
import { getDossierInfos } from '../Utils';
import YesNoDialog from '../YesNoDialog';
import { v4 as uuidv4 } from "uuid";
import "../../Styles/CISSCT/Convocation.scss";
import GenPdf from "../GenPdf";

const Convocation = () => {
  const dispatch = useDispatch();

  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const index = useSelector((state) => state.cissct.index);
  const cissctList = useSelector((state) => state.cissct.items);

  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [newMemberInput, setNewMemberInput] = useState("");
  const [newOrganizationInput, setNewOrganizationInput] = useState("");
  const [isCustomType, setIsCustomType] = useState(false);
  const [customTypeValue, setCustomTypeValue] = useState("");

  const [formData, setFormData] = useState({
    date: new Date().toISOString().slice(0, 10),
    meetingType: "Installation CISSCT",
    meetingDate: "",
    meetingTime: "",
    meetingLocation: "",
    agenda: "",
    operation: "",
    address: "",
    projectOwner: "",
    projectManager: "",
    spsCoordinator: "COORDOGEC",
    worksDirector: "",
    cissctPresident: "",
    invitees: [
      { id: uuidv4(), role: "Entreprises titulaires", type: "convocation", selected: true, isDefault: true },
      { id: uuidv4(), role: "Sous-traitants", type: "convocation", selected: true, isDefault: true },
      { id: uuidv4(), role: "Représentants des salariés", type: "convocation", selected: false, isDefault: true }
    ],
    guestOrganizations: [
      { id: uuidv4(), organization: "Inspection du travail", type: "invitation", selected: true, isDefault: true },
      { id: uuidv4(), organization: "Médecin du travail / Service de santé au travail", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "OPPBTP (Organisme Professionnel de Prévention du Bâtiment et des Travaux Publics)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "CARSAT / CRAM (Caisse d'Assurance Retraite et de la Santé au Travail)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "CPAM (Caisse Primaire d'Assurance Maladie)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "Organisme de contrôle technique (SOCOTEC, Bureau Veritas, DEKRA, etc.)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "Organisme certificateur / Vérificateur (CTS)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "INRS (Institut National de Recherche et de Sécurité)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "ANACT (Agence Nationale pour l'Amélioration des Conditions de Travail)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "DREAL (Direction Régionale de l'Environnement, de l'Aménagement et du Logement)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "Préfecture / Service de défense incendie (SDIS)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "IPRP externe (Intervenant en Prévention des Risques Professionnels)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "CRAMIF (Île-de-France) / Service de prévention", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "ARS (Agence Régionale de Santé)", type: "invitation", selected: false, isDefault: true },
      { id: uuidv4(), organization: "Organisme paritaire interentreprises (OPI)", type: "invitation", selected: false, isDefault: true }
    ],
    legalNoticeText:
      "Conformément aux dispositions relatives au collège interentreprises de sécurité, de santé et des conditions de travail, la présente convocation est adressée aux membres du CISSCT, et une invitation est transmise à l'inspection du travail et aux organismes de prévention concernés. \nLa présence des personnes convoquées est requise afin de garantir la mise en œuvre effective des mesures de prévention, de sécurité et de protection de la santé des travailleurs sur le chantier."
  });

  const INSTALLATION_AGENDA =
    "- Installation officielle du Collège interentreprises de sécurité, de santé et des conditions de travail (CISSCT) conformément aux articles R. 4532-81 à 85 du Code du travail\n" +
    "- Présentation des entreprises intervenantes et désignation des représentants titulaires/suppléants\n" +
    "- Rappel des obligations réglementaires en matière de coordination SPS\n" +
    "- Élection du président et du secrétaire du CISSCT (Coordonnateur SPS président de droit)\n" +
    "- Fixation du règlement intérieur et des modalités d'organisation des réunions (fréquence minimum trimestrielle)\n" +
    "- Présentation du plan général de coordination SPS et des mesures de prévention prévues\n" +
    "- Visite d'inspection du chantier programmée\n" +
    "- Questions diverses";

  const PERIODIC_MEETING_AGENDA =
    "- Approbation du compte rendu de la précédente réunion et suivi des actions décidées\n" +
    "- Examen des accidents du travail, incidents et quasi-accidents survenus depuis la dernière réunion (déclaration CRAM/CARSAT)\n" +
    "- Bilan de mise en œuvre des mesures de prévention et suivi des prescriptions de l'Inspection du travail\n" +
    "- Présentation des nouvelles phases de travaux et analyse des risques associés (DUT, PSS, EPI)\n" +
    "- Contrôle des installations collectives (base-vie, accès, sanitaires, EPI collectifs)\n" +
    "- Point sur les sous-traitances et coordination inter-entreprises\n" +
    "- Questions des représentants du personnel et échanges avec l'Inspection du travail\n" +
    "- Visite d'inspection du chantier et points de vigilance\n" +
    "- Questions diverses";

  const EXTRAORDINARY_MEETING_AGENDA =
    "- Constatation de l'événement déclencheur\n" +
    "- Analyse immédiate des causes directes et racines\n" +
    "- Mesures d'urgence prises et communication effectuée (Inspection du travail, CARSAT, médecin du travail)\n" +
    "- Réexamen des procédures de coordination SPS et PPSPS concernées\n" +
    "- Plan d'actions correctives immédiates avec responsables désignés et échéances\n" +
    "- Mesures de prévention renforcées et formation du personnel\n" +
    "- Communication aux sous-traitants et modification des permis de travaux\n" +
    "- Contrôles renforcés et suivi par le Coordonnateur SPS\n" +
    "- Questions diverses";

  const [errors, setErrors] = useState({});

  // Fonction pour récupérer les données du dossier
  const fetchData = useCallback(async () => {
    if (!dossierValue) return;
    setIsLoading(true);

    try {
      const result = await getDossierInfos(dossierValue);

      setFormData({
        date: new Date().toISOString().slice(0, 10),
        meetingType: "Installation CISSCT",
        meetingDate: new Date().toISOString().slice(0, 10),
        meetingTime: "09:00",
        meetingLocation: `${result.adresse_op}, ${result.cp_op} - ${result.ville_op}`,
        agenda: INSTALLATION_AGENDA,
        operation: result.operation,
        address: `${result.adresse_op}, ${result.cp_op} - ${result.ville_op}`,
        projectOwner: result.sci_sccv,
        projectManager: "",
        spsCoordinator: 'COORDOGEC',
        worksDirector: "",
        cissctPresident: '',
        invitees: [
          { id: uuidv4(), role: "Entreprises titulaires", type: "convocation", selected: true, isDefault: true },
          { id: uuidv4(), role: "Sous-traitants", type: "convocation", selected: true, isDefault: true },
          { id: uuidv4(), role: "Représentants des salariés", type: "convocation", selected: false, isDefault: true }
        ],
        guestOrganizations: [
          { id: uuidv4(), organization: "Inspection du travail", type: "invitation", selected: true, isDefault: true },
          { id: uuidv4(), organization: "Médecin du travail / Service de santé au travail", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "OPPBTP (Organisme Professionnel de Prévention du Bâtiment et des Travaux Publics)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "CARSAT / CRAM (Caisse d'Assurance Retraite et de la Santé au Travail)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "CPAM (Caisse Primaire d'Assurance Maladie)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "Organisme de contrôle technique (SOCOTEC, Bureau Veritas, DEKRA, etc.)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "Organisme certificateur / Vérificateur (CTS)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "INRS (Institut National de Recherche et de Sécurité)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "ANACT (Agence Nationale pour l'Amélioration des Conditions de Travail)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "Préfecture / Service de défense incendie (SDIS)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "IPRP externe (Intervenant en Prévention des Risques Professionnels)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "CRAMIF (Île-de-France) / Service de prévention", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "ARS (Agence Régionale de Santé)", type: "invitation", selected: false, isDefault: true },
          { id: uuidv4(), organization: "Organisme paritaire interentreprises (OPI)", type: "invitation", selected: false, isDefault: true }
        ],
        legalNoticeText:
          "Conformément aux dispositions relatives au collège interentreprises de sécurité, de santé et des conditions de travail, la présente convocation est adressée aux membres du CISSCT, et une invitation est transmise à l'inspection du travail et aux organismes de prévention concernés.\nLa présence des personnes convoquées est requise afin de garantir la mise en œuvre effective des mesures de prévention, de sécurité et de protection de la santé des travailleurs sur le chantier."
      });
      setIsCustomType(false);
      setCustomTypeValue("");

    } catch (error) {
      console.error("Erreur lors de la récupération des informations:", error);
    } finally {
      setIsLoading(false);
    }
  }, [dossierValue]);

  // Fonction pour sauvegarder les données
  const handleSaveClick = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    setIsLoading(true);
    try {
      const requestOptions = {
        ndossier: dossierValue,
        index: index,
        data: JSON.stringify(formData)
      };

      const response = await axios.post('/api/cissct/saveConvocation', requestOptions, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status !== 200) {
        throw new Error("Erreur lors de l'enregistrement de la convocation CISSCT");
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de la convocation CISSCT:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateConvocation = async () => {
    setOpenDialogCreate(false);
    setIsLoading(true);
    try {
      const requestOptions = {
        ndossier: dossierValue,
        index: cissctList.length + 1,
        data: JSON.stringify(formData)
      };

      const response = await axios.post('/api/cissct/createConvocation', requestOptions, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status !== 200) {
        throw new Error("Erreur lors de la création de convocation CISSCT");
      }

      await dispatch(fetchCissct(dossierValue));
      await dispatch(changeIndexValue(index + 1));
    } catch (error) {
      console.error("Erreur lors de la création de convocation CISSCT:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour récupérer une convocation existante
  const handleGetConvocation = useCallback(async () => {
    if (!dossierValue || !index) return;
    setIsLoading(true);

    try {
      const response = await axios.get(`/api/cissct/getConvocation/${dossierValue}/${index}`);
      const parsed = JSON.parse(response.data.data);

      const standardTypes = [
        "Installation CISSCT",
        "Réunion périodique",
        "Réunion extraordinaire"
      ];

      setFormData(prev => ({
        ...prev,
        ...parsed
      }));

      if (parsed.meetingType && !standardTypes.includes(parsed.meetingType)) {
        setIsCustomType(true);
        setCustomTypeValue(parsed.meetingType);
      } else {
        setIsCustomType(false);
        setCustomTypeValue("");
      }

    } catch (error) {
      if (error.response) {
        const status = error.response.status;

        if (status === 404) {
          fetchData();
          return;
        }

        console.error("Erreur API:", error.response.data?.error || error.message);
      } else {
        console.error("Erreur réseau:", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  }, [dossierValue, index, fetchData]);


  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "meetingType") {
      if (value === "Autre") {
        setIsCustomType(true);
        setFormData(prev => ({ ...prev, meetingType: "", agenda: "" }));
        return;
      }
      setIsCustomType(false);
      setCustomTypeValue("");
      setFormData(prev => ({
        ...prev,
        meetingType: value,
        agenda: value === "Installation CISSCT" ? INSTALLATION_AGENDA :
          value === "Réunion périodique" ? PERIODIC_MEETING_AGENDA :
            EXTRAORDINARY_MEETING_AGENDA
      }));
      if (errors.meetingType) {
        setErrors(prev => ({ ...prev, meetingType: null }));
      }
      return;
    }

    handleInputChange(name, value);
  };

  const handleCustomTypeChange = (e) => {
    const value = e.target.value;
    setCustomTypeValue(value);
    setFormData(prev => ({ ...prev, meetingType: value }));
  };

  const handleBackToSelect = () => {
    setIsCustomType(false);
    setCustomTypeValue("");
    setFormData(prev => ({ ...prev, meetingType: "Installation CISSCT", agenda: INSTALLATION_AGENDA }));
  };

  const handleToggleInvitee = (index, listKey) => {
    setFormData(prev => ({
      ...prev,
      [listKey]: prev[listKey].map((item, i) =>
        i === index ? { ...item, selected: !item.selected } : item
      )
    }));
  };

  const handleAddMember = () => {
    const trimmedValue = newMemberInput.trim();
    if (!trimmedValue) return;

    const exists = formData.invitees.some(
      item => item.role.toLowerCase() === trimmedValue.toLowerCase()
    );
    if (exists) {
      alert("Ce membre existe déjà dans la liste");
      return;
    }

    setFormData(prev => ({
      ...prev,
      invitees: [
        ...prev.invitees,
        {
          id: uuidv4(),
          role: trimmedValue,
          type: "convocation",
          selected: true,
          isDefault: false
        }
      ]
    }));
    setNewMemberInput("");
  };


  const handleAddOrganization = () => {
    const trimmedValue = newOrganizationInput.trim();
    if (!trimmedValue) return;

    const exists = formData.guestOrganizations.some(
      item => item.organization.toLowerCase() === trimmedValue.toLowerCase()
    );
    if (exists) {
      alert("Cet organisme existe déjà dans la liste");
      return;
    }

    setFormData(prev => ({
      ...prev,
      guestOrganizations: [
        ...prev.guestOrganizations,
        {
          id: uuidv4(),
          organization: trimmedValue,
          type: "invitation",
          selected: true,
          isDefault: false
        }
      ]
    }));
    setNewOrganizationInput("");
  };


  const handleRemoveMember = (index) => {
    setFormData(prev => ({
      ...prev,
      invitees: prev.invitees.filter((_, i) => i !== index)
    }));
  };

  const handleRemoveOrganization = (index) => {
    setFormData(prev => ({
      ...prev,
      guestOrganizations: prev.guestOrganizations.filter((_, i) => i !== index)
    }));
  };

  const handleKeyDownMember = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddMember();
    }
  };

  const handleKeyDownOrganization = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddOrganization();
    }
  };


  const handleOpenMapWithAddress = async () => {
    try {
      if (formData.address) {
        await navigator.clipboard.writeText(formData.address);
      }

      window.open('https://lespacedescartes.maps.arcgis.com/apps/webappviewer/index.html?id=36f7a547385c42e4b37ae2e9f8a51fc6', '_blank');
    } catch (err) {
      console.error('Erreur lors de la copie dans le presse-papier:', err);
      window.open('https://lespacedescartes.maps.arcgis.com/apps/webappviewer/index.html?id=36f7a547385c42e4b37ae2e9f8a51fc6', '_blank');
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.meetingDate) newErrors.meetingDate = "Date obligatoire";
    if (!formData.meetingTime) newErrors.meetingTime = "Heure obligatoire";
    if (!formData.meetingLocation) newErrors.meetingLocation = "Lieu obligatoire";
    if (!formData.operation) newErrors.operation = "Opération obligatoire";
    if (!formData.address) newErrors.address = "Adresse obligatoire";
    if (!formData.projectOwner) newErrors.projectOwner = "Maître d'ouvrage obligatoire";
    if (!formData.spsCoordinator) newErrors.spsCoordinator = "Coordonnateur SPS obligatoire";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleGeneratePdfLocal = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    setIsLoading(true);
    setFile(null);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        ndossier: dossierValue,
        index: index,
        data: formData
      }),
    };

    let blob = await fetch("/api/cissct/genConvocationPdf", requestOptions)
      .then((res) => res.blob())
      .catch((err) => {
        console.log(err);
      });

    if (blob) {
      setFile(blob);
      setIsOpen(true);
    }
    setIsLoading(false);
  };

  const handleShowPdf = useCallback(async () => {
    setIsLoading(true);
    setFile(null);
    try {
      const response = await fetch(`/api/cissct/getConvocationPdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ndossier: dossierValue,
          index: index,
          type: 'pdf',
        }),
      });
      const blob = await response.blob();
      if (blob.size > 100) {
        const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1] || `CISSCT_CONVOCATION_${index}.pdf`;
        dispatch(changePdfFileName(fileName));
        setFile(blob);
        setIsOpen(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }, [dossierValue, index, dispatch]);

  const handleGetWordFile = useCallback(async () => {
    setIsLoading(true);
    setFile(null);
    try {
      const response = await fetch(`/api/cissct/getConvocationPdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ndossier: dossierValue,
          index: index,
          type: 'word',
        }),
      });
      const blob = await response.blob();
      if (blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1] || `CISSCT_CONVOCATION_${index}.pdf`;
        dispatch(changePdfFileName(fileName));
        setFile(blob);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }, [dossierValue, index, dispatch]);

  const handleGetPdfFile = useCallback(async () => {
    setIsLoading(true);
    setFile(null);
    try {
      const response = await fetch(`/api/cissct/getConvocationPdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ndossier: dossierValue,
          index: index,
          type: 'pdf',
        }),
      });
      const blob = await response.blob();
      if (blob.size > 100) {
        const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1] || `CISSCT_CONVOCATION_${index}.pdf`;
        dispatch(changePdfFileName(fileName));
        setFile(blob);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }, [dossierValue, index, dispatch]);

  const handleChangeTitleName = () => {
    dispatch(changeTitleName(`Convocation CISSCT`));
  };

  useEffect(() => {
    handleGetConvocation();
  }, [dossierValue, handleGetConvocation]);

  useEffect(() => {
    dispatch(changeIndication("Convocation CISSCT"));
    handleChangeTitleName();
  }, []);

  return (
    <div className="cissct-convocation">
      {isLoading && <LoadingOverlay />}
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
        updateIndication={() => dispatch(changeIndication('Convocation CISSCT'))}
      />
      <h1 className="title">Convocation & Invitation CISSCT</h1>
      <NumDossCISSCT />

      <div className="container">

        <div className="form-content">
          {/* Section Informations réunion */}
          <div className="form-section">
            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="operation">Date *</label>
                <input
                  id="date"
                  type="date"
                  name='date'
                  style={{ width: '150px' }}
                  value={formData.date}
                  onChange={handleChange}
                />
              </div>
            </div>
            <h2 className="section-title">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
              </svg>
              Informations de la Réunion
            </h2>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="meetingType">Type de réunion *</label>
                {isCustomType ? (
                  <div className="custom-type-wrapper">
                    <input
                      type="text"
                      value={customTypeValue}
                      onChange={handleCustomTypeChange}
                      placeholder="Précisez le type de réunion..."
                      autoFocus
                    />
                    <button
                      type="button"
                      className="btn-cancel-custom"
                      onClick={handleBackToSelect}
                      title="Revenir à la liste"
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <select
                    id="meetingType"
                    name="meetingType"
                    value={formData.meetingType}
                    onChange={handleChange}
                  >
                    <option>Installation CISSCT</option>
                    <option>Réunion périodique</option>
                    <option>Réunion extraordinaire</option>
                    <option>Autre</option>
                  </select>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="meetingDate">Date de la réunion *</label>
                <input
                  type="date"
                  id="meetingDate"
                  name="meetingDate"
                  value={formData.meetingDate}
                  onChange={handleChange}
                  className={errors.meetingDate ? 'error' : ''}
                />
                {errors.meetingDate && <span className="error-message">{errors.meetingDate}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="meetingTime">Heure *</label>
                <input
                  type="time"
                  id="meetingTime"
                  name="meetingTime"
                  value={formData.meetingTime}
                  onChange={handleChange}
                  className={errors.meetingTime ? 'error' : ''}
                />
                {errors.meetingTime && <span className="error-message">{errors.meetingTime}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="meetingLocation">Lieu de la réunion *</label>
                <input
                  type="text"
                  id="meetingLocation"
                  name="meetingLocation"
                  value={formData.meetingLocation}
                  onChange={handleChange}
                  placeholder="Salle de réunion, base-vie, siège..."
                  className={errors.meetingLocation ? 'error' : ''}
                />
                {errors.meetingLocation && <span className="error-message">{errors.meetingLocation}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="agenda">Ordre du jour (synthèse)</label>
                <textarea
                  id="agenda"
                  name="agenda"
                  value={formData.agenda}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Ex : Installation du CISSCT, présentation des entreprises, plan de prévention..."
                />
              </div>
            </div>
          </div>

          {/* Section Chantier & acteurs */}
          <div className="form-section">
            <h2 className="section-title">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
              </svg>
              Chantier & Acteurs du Projet
            </h2>

            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="operation">Opération *</label>
                <input
                  type="text"
                  id="operation"
                  name="operation"
                  value={formData.operation}
                  onChange={handleChange}
                  placeholder="Ex : Construction d'un immeuble R+8"
                  className={errors.operation ? 'error' : ''}
                />
                {errors.operation && <span className="error-message">{errors.operation}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="address">Adresse du chantier *</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Ex : 123 Rue de la République, 75001 - Paris"
                  className={errors.address ? 'error' : ''}
                />
                {errors.address && <span className="error-message">{errors.address}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="projectOwner">Maître d'ouvrage *</label>
                <input
                  type="text"
                  id="projectOwner"
                  name="projectOwner"
                  value={formData.projectOwner}
                  onChange={handleChange}
                  className={errors.projectOwner ? 'error' : ''}
                />
                {errors.projectOwner && <span className="error-message">{errors.projectOwner}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="projectManager">Maître d'œuvre</label>
                <input
                  type="text"
                  id="projectManager"
                  name="projectManager"
                  value={formData.projectManager}
                  onChange={handleChange}
                  placeholder="Optionnel"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="spsCoordinator">Coordonnateur SPS *</label>
                <input
                  type="text"
                  id="spsCoordinator"
                  name="spsCoordinator"
                  value={formData.spsCoordinator}
                  onChange={handleChange}
                  className={errors.spsCoordinator ? 'error' : ''}
                />
                {errors.spsCoordinator && <span className="error-message">{errors.spsCoordinator}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="worksDirector">Directeur de travaux</label>
                <input
                  type="text"
                  id="worksDirector"
                  name="worksDirector"
                  value={formData.worksDirector}
                  onChange={handleChange}
                  placeholder="Optionnel"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="cissctPresident">Président du CISSCT</label>
                <input
                  type="text"
                  id="cissctPresident"
                  name="cissctPresident"
                  value={formData.cissctPresident}
                  onChange={handleChange}
                  placeholder="Ex : Coordonnateur SPS"
                />
              </div>
            </div>
          </div>

          {/* Section Convocation des membres */}
          <div className="form-section">
            <h2 className="section-title">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z" />
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
              </svg>
              Convocation des membres
            </h2>

            <p className="help-text">
              Les personnes ci-dessous reçoivent une convocation officielle à la réunion du CISSCT.
            </p>

            <div className="chips-container">
              {formData.invitees.map((item, index) => (
                <button
                  key={item.id}
                  type="button"
                  className={`chip ${item.selected ? "chip-active" : ""}`}
                  onClick={() => handleToggleInvitee(index, "invitees")}
                >
                  {item.role}
                  {!item.isDefault && (
                    <span
                      className="chip-remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveMember(index);
                      }}
                      title="Supprimer"
                    >
                      ×
                    </span>
                  )}
                </button>
              ))}
            </div>

            <div className="add-item-row">
              <input
                type="text"
                value={newMemberInput}
                onChange={(e) => setNewMemberInput(e.target.value)}
                onKeyDown={handleKeyDownMember}
                placeholder="Ajouter un membre (ex: Chef de chantier)"
              />
              <button
                type="button"
                onClick={handleAddMember}
                disabled={!newMemberInput.trim()}
              >
                + Ajouter
              </button>
            </div>
          </div>

          {/* Section Invitation des organismes */}
          <div className="form-section">
            <h2 className="section-title">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z" />
              </svg>
              Invitation des organismes
            </h2>

            <p className="help-text">
              Ces organismes reçoivent une invitation (inspection du travail, organismes de prévention, etc.).
            </p>

            <div className="chips-container">
              {formData.guestOrganizations.map((item, index) => (
                <Fragment key={item.id}>
                  <button
                    type="button"
                    className={`chip chip-outline ${item.selected ? "chip-active" : ""}`}
                    onClick={() => handleToggleInvitee(index, "guestOrganizations")}
                  >
                    {item.organization}
                    {!item.isDefault && (
                      <span
                        className="chip-remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveOrganization(index);
                        }}
                        title="Supprimer"
                      >
                        ×
                      </span>
                    )}
                  </button>
                  {item.organization === "Inspection du travail" && (
                    <IconButton
                      size="small"
                      onClick={handleOpenMapWithAddress}
                      title="Ouvrir l'annuaire de la DRIEETS"
                      style={{ padding: "2px", color: "#1976d2" }}
                    >
                      <LaunchIcon style={{ fontSize: "16px" }} />
                    </IconButton>
                  )}
                </Fragment>
              ))}
            </div>

            <div className="add-item-row">
              <input
                type="text"
                value={newOrganizationInput}
                onChange={(e) => setNewOrganizationInput(e.target.value)}
                onKeyDown={handleKeyDownOrganization}
                placeholder="Ajouter un organisme (ex: OPPBTP)"
              />
              <button
                type="button"
                onClick={handleAddOrganization}
                disabled={!newOrganizationInput.trim()}
              >
                + Ajouter
              </button>
            </div>

            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="legalNoticeText">Texte de mention juridique / rappel</label>
                <textarea
                  id="legalNoticeText"
                  name="legalNoticeText"
                  value={formData.legalNoticeText}
                  onChange={handleChange}
                  rows={3}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="group-btn">
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenDialogCreate(true)}
          // disabled={disableButton}
          >
            Créer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSaveClick}
            disabled={!index}
          >
            Enregistrer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={handleGeneratePdfLocal}
            disabled={!index}
          >
            Générer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<VisibilityIcon />}
            onClick={handleShowPdf}
            disabled={!index}
          >
            Afficher
          </Button>
          <Button
            variant="contained"
            className="btn-reset"
            onClick={fetchData}
            disabled={!index}
          >
            Annuler
          </Button>
        </div>
      </div>

      <GenPdf
        file={file}
        isOpen={isOpen}
        closeDoc={() => setIsOpen(false)}
        scale={1}
      />
      <YesNoDialog
        isOpen={openDialogCreate}
        title={"CREATION - CONVOCATION"}
        question={`Êtes-vous sûr de vouloir créer une nouvelle convocation?`}
        handleYesClick={handleCreateConvocation}
        handleClose={() => setOpenDialogCreate(false)}
      />
    </div>
  );
};

export default Convocation;
